import BaseService from "services/base";
import { builder } from "utils/graphql";
import {
  BOOKING_SLOT_SELECTION,
  LOAD_BOOKING_SLOT_SELECTION,
  bookingSlotCount,
  bookingSlotOff,
} from "./constant";
import { get, omit } from "utils/lodash";
import { toUTCString } from "utils/dayjs";
class Service extends BaseService {
  name = "BookingSlot";
  static override DEFINITION = builder.createDefinition({
    name: "BookingSlot",
    baseQuery: "BookingSlot",
    baseSelection: `
        ${BOOKING_SLOT_SELECTION}
      `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
    },
    GQL_ACTIONS: {
      FIND: "BookingSlots",
    },
    GQL_RESPONSE_DATA_PATH: {
      BASE: "data.BookingSlot",
      FIND: "data.BookingSlots.docs",
      PARAMS: "data.BookingSlots",
    },
  });
  async loadBookingSlots(options: any) {
    const nameQuery = "BookingSlots";
    const date = get(options, "date", "");
    const slotOffLimit = get(options, "slotOffLimit", 1);
    const slotOffPage = get(options, "slotOffPage");
    const slotOffSort = get(options, "slotOffSort", "date");
    
    const opts = omit(options, ["date", "slotOffLimit", "slotOffPage", "slotOffSort", "slotOffWhere"]);
    
    // Add date to variables if it exists
    if (date && opts.variables) {
      opts.variables.date = toUTCString(date);
    }

    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}.docs`,
          PARAMS: "data.BookingSlots",
        },

        ...opts,
      },
      `query ${nameQuery}($limit: Int, $page: Int, $sort: String, $where: BookingSlot_where${date ? ', $date: DateTime' : ''}) {
        ${nameQuery}(limit: $limit, page: $page, sort: $sort, where: $where) {
          docs {
            ${LOAD_BOOKING_SLOT_SELECTION}
            ${bookingSlotOff(
              undefined,  // Don't pass date directly since we're using variable
              slotOffLimit, 
              slotOffPage, 
              slotOffSort,
              undefined,  // Don't pass custom where
              date ? true : false  // Use $date variable if date is provided
            )}
            ${bookingSlotCount(toUTCString(date))}
          }
          limit
          page
          offset
          totalDocs
          totalPages
        }
      }`
    );
  }
}

// export * from "./formatter";
export * from "./constant";
const Instance = new Service();

export default Instance;
